import React from 'react';

const ChartsIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.16699 0.666504V17.3332C3.94199 16.9165 0.666992 13.3415 0.666992 8.99984C0.666992 4.65817 3.94199 1.08317 8.16699 0.666504ZM9.85866 0.666504V8.15817H17.3337C16.942 4.20817 13.8003 1.05817 9.85866 0.666504ZM9.85866 9.8415V17.3332C13.8087 16.9415 16.942 13.7915 17.3337 9.8415H9.85866Z" fill="currentColor"/>
    </svg>
  )
}

export default ChartsIcon;